import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LatestEvent } from '../components/LatestEventOverlay/LatestEventOverlay.component';
import { devAPI, prodAPI } from '../../env';

@Injectable({
  providedIn: 'root'
})  
export class LatestEventService {

  constructor(private http: HttpClient) {}

  getLatestEvent(): Observable<LatestEvent> {
    return this.http.get<LatestEvent>(`${prodAPI}/api/overlay/notification`);
  }

  markEventAsShown(eventId: number): Observable<any> {
    return this.http.patch(`${prodAPI}/api/overlay/notification/${eventId}/mark-shown`, {});
  }
}
